export const SEARCH_DATA = [
  ["name", "BMG Farm"],
  ["abbreviation", "Abbreviation"],
];

